import React from 'react';

/**
 * Network error SVG Icon
 */
export const NetworkErrorIcon = (): JSX.Element => (
    <svg viewBox="0 0 150 150">
        <defs />
        <g id="Error-Disconnected-Color">
            <radialGradient
                id="Path_14_"
                cx="-218.6093"
                cy="491.7"
                r=".5686"
                gradientTransform="matrix(104.303 0 0 -104.3031 22933.4668 51400.5352)"
                gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#b3afab" />
                <stop offset="1" stop-color="#e1dfdd" />
            </radialGradient>
            <path
                id="Path"
                fill="url(#Path_14_)"
                fill-rule="evenodd"
                d="M102.3 112.6l-69.6 18.8c-.8.2-1.6.1-2.3-.3-.7-.4-1.2-1-1.4-1.8L.3 22.6c-.4-1.6.5-3.2 2.1-3.7L72 .2c1.6-.4 3.2.5 3.7 2.1L104.5 109c.2.8.1 1.6-.3 2.3-.5.6-1.1 1.1-1.9 1.3"
                clip-rule="evenodd"
            />
            <path
                id="Path_1_"
                fill="#fff"
                fill-rule="evenodd"
                d="M58.9 55.5l-17.4 4.7c-3.1.8-6.3.4-9-1.2s-4.7-4.2-5.6-7.2l-3.5-12.9c-1.7-6.4 2-12.9 8.4-14.6l17.4-4.7c3.1-.8 6.3-.4 9 1.2s4.7 4.2 5.6 7.2l3.5 12.9c1.7 6.4-2 12.9-8.4 14.6"
                clip-rule="evenodd"
            />
            <path
                id="Path_2_"
                fill="#b3afab"
                fill-rule="evenodd"
                d="M55.3 43.2c-.9.2-1.9-.3-2.1-1.2l-3.9-14.6c-.2-.6 0-1.2.4-1.7.4-.4 1.1-.6 1.7-.5.6.2 1.1.6 1.2 1.2l4 14.6c.1.4.1.9-.2 1.3-.3.5-.6.8-1.1.9"
                clip-rule="evenodd"
            />
            <path
                id="Path_3_"
                fill="#fff"
                fill-rule="evenodd"
                d="M72.6 106.1l-17.4 4.7c-6.4 1.7-12.9-2-14.6-8.4l-3.5-13c-.8-3.1-.4-6.3 1.2-9s4.2-4.7 7.2-5.6l17.4-4.7c6.4-1.7 12.9 2 14.6 8.4l3.5 13c1.7 6.3-2.1 12.9-8.4 14.6"
                clip-rule="evenodd"
            />
            <path
                id="Path_4_"
                fill="#b3afab"
                fill-rule="evenodd"
                d="M38.5 47.8c-.9.2-1.8-.3-2.1-1.2l-4-14.7c-.2-.6 0-1.2.4-1.7.4-.4 1.1-.6 1.7-.5.6.2 1.1.6 1.2 1.2l3.9 14.7c.1.4.1.9-.2 1.3-.1.5-.5.8-.9.9"
                clip-rule="evenodd"
            />
            <path
                id="Path_5_"
                fill="#b3afab"
                fill-rule="evenodd"
                d="M49.6 49c.2.7-.1 1.4-.6 1.9-.6.4-1.3.5-2 .1s-1-1.1-.9-1.8c.1-.7.6-1.3 1.3-1.5 1-.2 2 .3 2.2 1.3"
                clip-rule="evenodd"
            />
            <path
                id="Path_6_"
                fill="#b3afab"
                fill-rule="evenodd"
                d="M52.1 98.4c-.4.1-.9.1-1.3-.2-.4-.2-.7-.6-.8-1.1l-4-14.6c-.2-.9.3-1.8 1.2-2.1.9-.2 1.8.3 2.1 1.1l3.9 14.6c.1.4.1.9-.2 1.3-.1.5-.5.8-.9 1"
                clip-rule="evenodd"
            />
            <path
                id="Path_7_"
                fill="#b3afab"
                fill-rule="evenodd"
                d="M68.9 93.8c-.9.2-1.9-.3-2.1-1.2L62.9 78c-.2-.6 0-1.2.4-1.7.4-.4 1.1-.6 1.7-.5.6.2 1.1.6 1.2 1.2l4 14.6c.2 1-.3 1.9-1.3 2.2"
                clip-rule="evenodd"
            />
            <path
                id="Path_8_"
                fill="#b3afab"
                fill-rule="evenodd"
                d="M63.3 99.6c.2.9-.3 1.9-1.2 2.1-.9.2-1.9-.3-2.1-1.2-.2-.9.3-1.9 1.2-2.1.4-.1.9-.1 1.3.2.4.1.7.5.8 1"
                clip-rule="evenodd"
            />
            <path
                id="Path_9_"
                fill="#ffd590"
                fill-rule="evenodd"
                d="M103.7 42.5l12-11c.1-.1.2-.1.4-.1s.2.2.2.3l1.4 5.3c0 .1.1.2.2.3.1.1.2 0 .3 0l8.8-4.6c.2-.1.4 0 .5.1.1.2.1.4-.1.5l-12.6 11.4c-.1.1-.2.1-.4.1-.1 0-.2-.2-.2-.3l-.9-5.8c0-.1-.1-.2-.2-.3-.1-.1-.2-.1-.3 0l-8.7 4.7c-.2.1-.4.1-.5-.1-.1-.1-.1-.3.1-.5"
                clip-rule="evenodd"
            />
            <path
                id="Path_10_"
                fill="#ffd590"
                fill-rule="evenodd"
                d="M96.1 33.1l1.4-22.8c0-.2.1-.4.3-.4.2-.1.4-.1.5.1l6.6 4c.1.1.3.1.5.1s.3-.2.3-.3L110.1.5c.1-.3.3-.4.6-.4s.4.3.4.6l-1.6 23.8c0 .2-.1.4-.3.4-.2.1-.4.1-.5-.1l-6.6-4.9c-.1-.1-.3-.1-.5-.1-.2.1-.3.2-.3.3l-4.2 13.3c-.1.3-.3.4-.6.4-.3-.1-.5-.4-.4-.7"
                clip-rule="evenodd"
            />
            <path
                id="Path_11_"
                fill="#3e8eed"
                d="M147.2 88.2L100.6 72c-1.4-.5-3 .3-3.5 1.7L91.4 90c-4.7 13.4 1.7 28.2 14.7 34.1-.9 3.2-3.9 10.2-8.9 10.8-4.1.5-6.1-1.4-9-4-3.5-3.2-8-7.1-16.2-5.2-11.6 2.7-15 13.9-15.2 19.5 0 1 .3 1.9 1 2.6.7.7 1.6 1.1 2.6 1.2h.1c2 0 3.6-1.6 3.7-3.5 0-.1.5-10.5 9.6-12.6 4.6-1 6.6.8 9.7 3.5 3.3 2.9 7.4 6.6 14.7 5.7 9.9-1.1 14-12.4 15.1-16 13.1 2 25.7-5.6 30.1-18l5.7-16.4c.3-1.4-.5-2.9-1.9-3.5z"
            />
            <path
                id="Path_12_"
                fill="#e1dfdd"
                fill-rule="evenodd"
                d="M144.5 60.2c-.9-.3-1.9-.3-2.8.2s-1.5 1.2-1.9 2.1l-7.2 20.7 6.9 2.4 7.2-20.7c.3-.9.3-1.9-.2-2.8-.4-.9-1.1-1.6-2-1.9"
                clip-rule="evenodd"
            />
            <path
                id="Path_13_"
                fill="#e1dfdd"
                fill-rule="evenodd"
                d="M120.3 51.7c-1.9-.7-4 .3-4.7 2.2l-7.2 20.7 6.9 2.4 7.2-20.7c.3-.9.3-1.9-.2-2.8-.3-.8-1.1-1.5-2-1.8"
                clip-rule="evenodd"
            />
        </g>
    </svg>
);
